module.exports = __webpack_public_path__ + "img/box-02.0bada666.svg";